import { toSnakeCaseDeep } from 'src/utils/transform';
import { stringifyUrl } from 'src/utils/stringifyUrl';
import MemriseApi from '../MemriseApi';
import {
  ScenariosResponseDetailed,
  RecommendedScenariosResponse,
  TopicsResponse,
  LanguagePairScenariosGroupedByTopicList,
} from './schema';

export default class ScenarioApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/scenarios' });
  }

  public async getScenario(
    scenarioId: string,
    query?: {
      includeMetadata?: boolean;
      includeLabel?: boolean;
    },
  ): Promise<ScenariosResponseDetailed> {
    const url = stringifyUrl(`/${scenarioId}/`, toSnakeCaseDeep(query));
    return await this.get(url);
  }

  public async getScenarioRecommendations(
    scenarioId: string | number,
  ): Promise<RecommendedScenariosResponse> {
    return await this.get(`/${scenarioId}/recommendations/`);
  }

  public async getScenarioLanguageByPairId(languageId: string | number): Promise<TopicsResponse> {
    return await this.get(`/?language_pair_id=${languageId}`);
  }

  public async getLanguagePairScenariosGroupedByTopic(query: {
    includeMetadata?: boolean;
    includeLicLabels?: boolean;
    languagePairId: number;
    topicId?: number;
  }): Promise<LanguagePairScenariosGroupedByTopicList> {
    return await this.get(stringifyUrl('/', toSnakeCaseDeep(query)));
  }
}

export const ScenarioApi = new ScenarioApiClass();
